import { PropsWithChildren } from 'react';
import Tooltip from '@/common/helios/Tooltip';

const OnHoldTooltip = ({ children }: PropsWithChildren) => (
  <div className="flex">
    <Tooltip
      content={
        <>
          Another customer recently began the process to purchase this vehicle,
          so we’re holding it for them temporarily, just like we will for you.
          Frequently, customers do not move forward during this hold time and
          the vehicle becomes available again.
        </>
      }
      direction="bottom-start"
      title="This Vehicle Is On Hold"
    >
      <span className="flex items-center gap-sm pointer-events-auto">
        {children}
      </span>
    </Tooltip>
  </div>
);

export default OnHoldTooltip;
